const popWindow = (url: string) => {
  const height = window.screen.height / 1.5;
  const width = window.screen.width / 1.5;
  const top = window.screen.height / 2 - height / 2;
  const left = window.screen.width / 2 - width / 2;
  const features = `height=${height}, width=${width}, top=${top}, left=${left}`;

  window.open(url, undefined, features);
};

export { popWindow };
